var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EVCookiesBanner'),(_vm.isMobile)?_c('EVArPage'):_c('EVDesktopPage'),(_vm.isMobile)?_c('RotateHint'):_vm._e(),_c(_vm.fpsComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }